var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2389 2.01647L10.3385 2.90384L14.2122 6.77752L10.3385 10.6512L11.2389 11.5386L16 6.77752L11.2389 2.01647ZM0 0.461732V3.4091C0 4.51464 0.390316 5.45766 1.17095 6.23815C1.95144 7.01878 2.89446 7.4091 4 7.4091H9.74253L6.50042 10.6512L7.40084 11.5386L12.1619 6.77752L7.40084 2.01647L6.50042 2.90384L9.74253 6.14594H4C3.24421 6.14594 2.59916 5.87871 2.06484 5.34426C1.53039 4.80994 1.26316 4.16489 1.26316 3.4091V0.461732H0Z",
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForward);
export default __webpack_public_path__ + "static/media/icon_forward.a7c557a80cf01fd245db9e6107d9f488.svg";
export { ForwardRef as ReactComponent };